/**
 * tm-telemetry.js — production error log sender (theme v24.5, 2026-09-28)
 * ---------------------------------------------------------------------------
 * Sends failures, errors and a few attempt counts to our own log
 * (worker teddys-telemetry -> D1 teddys-telemetry), so a deploy can be checked
 * for new problems within minutes instead of waiting on GA4.
 *
 * Troubleshooting only. Nothing personal is sent: no photos, file names,
 * customer details or full URLs. The worker stores only the event names on its
 * allowlist and drops everything else.
 *
 * API: window.tmLog(eventName, params)   never throws, never blocks.
 *
 * Delivery: events are batched for a second, then POSTed as text/plain (a
 * simple request, so no CORS preflight) with keepalive so a batch survives the
 * page closing. A batch that can't be sent (offline, dropped connection) is
 * kept in localStorage and sent on the next page view, which is how the "no
 * signal at all" failures still arrive.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';
  if (window.tmLog) return;

  var ENDPOINT = 'https://teddys-telemetry.mark-hatlan.workers.dev/e';
  var QUEUE_KEY = 'tm_log_queue';
  var QUEUE_MAX = 40;        // oldest dropped beyond this
  var BATCH_MAX = 25;        // matches the worker's per-request cap
  var FLUSH_DELAY_MS = 1000;

  var pending = [];
  var timer = null;

  function themeId() {
    try { var S = window.Shopify; return String((S && S.theme && S.theme.id) || ''); }
    catch (e) { return ''; }
  }

  function readQueue() {
    try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]') || []; }
    catch (e) { return []; }
  }

  function writeQueue(list) {
    try {
      if (list.length) localStorage.setItem(QUEUE_KEY, JSON.stringify(list.slice(-QUEUE_MAX)));
      else localStorage.removeItem(QUEUE_KEY);
    } catch (e) { /* storage full or blocked: the events are lost, nothing breaks */ }
  }

  function keep(events) {
    for (var i = 0; i < events.length; i++) events[i].queued = 1;
    writeQueue(readQueue().concat(events));
  }

  function post(events) {
    if (!events.length) return;
    if (navigator.onLine === false) { keep(events); return; }
    try {
      // no-cors: we never read the reply, and it means only a real network
      // failure rejects. A CORS mismatch can't make a delivered batch look
      // failed and get queued twice.
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ events: events }),
        keepalive: true
      }).catch(function () { keep(events); });
    } catch (e) {
      keep(events);
    }
  }

  function flush() {
    clearTimeout(timer);
    timer = null;
    while (pending.length) post(pending.splice(0, BATCH_MAX));
  }

  window.tmLog = function (name, params) {
    try {
      var e = { event: String(name), client_ts: new Date().toISOString(), theme_id: themeId() };
      if (window.UPLOADER_BUILD) e.build = String(window.UPLOADER_BUILD);
      if (params) {
        for (var k in params) {
          if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
          var v = params[k];
          if (typeof v === 'number' || typeof v === 'boolean') e[k] = v;
          else if (v != null) e[k] = String(v).slice(0, 200);
        }
      }
      pending.push(e);
      if (pending.length >= BATCH_MAX) flush();
      else if (!timer) timer = setTimeout(flush, FLUSH_DELAY_MS);
    } catch (err) { /* logging must never break the page */ }
  };

  // Send what's waiting when the page is hidden or closed.
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });

  // Deliver anything a previous page view couldn't send.
  function drainQueue() {
    var q = readQueue();
    if (!q.length || navigator.onLine === false) return;
    writeQueue([]);
    while (q.length) post(q.splice(0, BATCH_MAX));
  }
  setTimeout(drainQueue, 1500);
  window.addEventListener('online', drainQueue);

  // Cart page: any script crash. Product pages are already covered by the
  // uploader's own uploader_js_error. Capped so one noisy app can't flood it.
  if (/^\/cart\/?$/.test(location.pathname)) {
    var sent = 0;
    var report = function (kind, msg) {
      if (sent >= 3) return;
      sent++;
      window.tmLog('cart_js_error', { fail_stage: 'js_' + kind, error_detail: String(msg || '').slice(0, 100) });
    };
    window.addEventListener('error', function (ev) {
      // Resource load failures (img, script) also arrive here with no message;
      // thumbnails are reported separately, so only real script errors count.
      if (ev && ev.message) report('error', ev.message);
    });
    window.addEventListener('unhandledrejection', function (ev) {
      var r = ev && ev.reason;
      report('rejection', r && (r.message || r.name));
    });
  }
})();
